import { coreService } from "../services/coreService";
import { FirstArgumentType, SecondArgumentType } from "../types/ArgumentTypes";
import { buildQuery } from "../lib/network";
import { ContentType } from "@gogovapps/core-service-client";

export type CoreLocationWithAllIncludes = Awaited<ReturnType<typeof coreService.locationsCreate>>["data"];
export type CoreLocationLocationAddress = CoreLocationWithAllIncludes["locationAddress"];
export type CoreLocationOwnerAddress = CoreLocationWithAllIncludes["ownerAddress"];

export type CoreCustomFieldValueAllIncludes = CoreLocationWithAllIncludes["customFieldValues"][number];

export type CoreCustomField = CoreCustomFieldValueAllIncludes["customField"];

export type CoreObjectType = CoreCustomField["resourceType"];

export type CoreCustomFieldType = CoreCustomField["type"];

export const createLocation = (headers: any) => (data: FirstArgumentType<typeof coreService.locationsCreate>) => {
  return buildQuery(coreService.locationsCreate(data, { headers }), (response) => {
    return response.data;
  });
};

export const getLocation = (headers: any) => (id: FirstArgumentType<typeof coreService.locationsDetail>) => {
  return buildQuery(coreService.locationsDetail(id, { headers }), (response) => {
    return response.data;
  });
};

export const updateLocation =
  (headers: any) =>
  ({
    id,
    data,
  }: {
    id: FirstArgumentType<typeof coreService.locationsUpdate>;
    data: SecondArgumentType<typeof coreService.locationsUpdate>;
  }) => {
    return buildQuery(coreService.locationsUpdate(id, data, { headers }), (response) => {
      return response.data;
    });
  };

export const deactivateLocation =
  (headers: any) =>
  ({ id }: { id: FirstArgumentType<typeof coreService.locationsDeactivatedUpdate> }) => {
    // Have to specify content type text here because cannot have an empty json body, api ignores body so it's okay
    return buildQuery(coreService.locationsDeactivatedUpdate(id, { headers, type: ContentType.Text }), (response) => {
      return response.data;
    });
  };

export const reactivateLocation =
  (headers: any) =>
  ({ id }: { id: FirstArgumentType<typeof coreService.locationsDeactivatedDelete> }) => {
    return buildQuery(coreService.locationsDeactivatedDelete(id, { headers, type: ContentType.Text }), (response) => {
      return response.data;
    });
  };

export const getLocationHistory =
  (headers: any) => (id: FirstArgumentType<typeof coreService.locationsHistoryDetail>) => {
    return buildQuery(coreService.locationsHistoryDetail(id, { headers }), (response) => {
      return response.data;
    });
  };

export const postLocationSearch =
  (headers: any) => (data: FirstArgumentType<typeof coreService.locationsSearchCreate>) => {
    return buildQuery(coreService.locationsSearchCreate(data, { headers }), (response) => {
      return response.data;
    });
  };

export const getCodeCasesForLocation =
  (headers: any) =>
  (
    id: FirstArgumentType<typeof coreService.locationsCodeEnforcementCasesDetail>,
    query: SecondArgumentType<typeof coreService.locationsCodeEnforcementCasesDetail>,
  ) => {
    return buildQuery(coreService.locationsCodeEnforcementCasesDetail(id, query, { headers }), (response) => {
      return response.data;
    });
  };
